import { init, initUserActionEvents } from '@ori/analytics-provider';
init();
initUserActionEvents();